import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Pet} from '../../shared/pets/pet';

@Component({
  selector: 'pet-selector',
  templateUrl: './pet-selector.component.html',
  styleUrls: ['./pet-selector.component.css']
})
export class PetSelectorComponent implements OnInit {
  isClosed = true;
  @Input()  petList: Pet[];
  @Input()  selectedPets: Pet[];
  @Output() petSelected: EventEmitter<Pet> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    console.log('Added Pet Selector Component with pets: ', this.petList);
  }

  onClicked(pet: Pet) {
    this.isClosed = true;
    this.petSelected.next(pet);
  }

}
